// extracted by mini-css-extract-plugin
export default {"fullscreen-container":"styles_fullscreen-container__OYdnc","hidden":"styles_hidden__SRKof"};